<template>
<div class="view start-view">
      <div id='cookie-dis' class='cookiepop' v-if="hasDisCookie === false">Vi använder cookies för att ge dig bästa möjliga upplevelse. Genom att använda webbplatsen accepterar du att cookies används. <a href='http://www.adobe.com/se/privacy/cookies.html' target='_blank'><u>Läs mer här</u></a><div class='cookie-close' v-on:click="closeCookie">✕</div></div>
      <div id="collage" class="section" v-if="true === false">
        <div class='collage-item' v-for='(slide, index) in winnerSlides' v-bind:style="{ backgroundImage: 'url(' + './static/min/' + slide.image + ')',  top: (getRandomPos(index))[0] + 'px', left: (getRandomPos(index))[1] + 'px', height: (getRandomSize(index))[1] + 'px', width: (getRandomSize(index))[0] + 'px' }"></div>
      </div>      
      <div class='section' style="margin-top: 0px;">
        <div class='content'>
          <!-- <div class='adobe-logo'></div> -->
          <div class="table-cell start-section">
            <div class='smile smile-crown'></div>
            <div class='smile smile-crop'></div>
            <div class='smile smile-key'></div>
            <div class='smile smile-sun'></div>
            <div class='smile smile-camera'></div>
            <div class='smile smile-levers'></div>
            <div class='smile smile-squares'></div>
            <div class="padding-40"></div>
            <div class="padding-80"></div>
            <div class='exs-title'>
              Exhibition
            </div>
            <div class='exs-sub-title'>
              Stockholm
            </div>
            <div class='new-logo'></div>
            <!--<div class='heading'>Bästa bilderna</div>
            <div class='sub-heading'>21 - 27 Augusti</div>-->
            <br><br>
            <router-link to="/winners" class="blue-butt" style="font-size: 0.9em;">Se utställda foton 2017</router-link><br><br>
            <!--<router-link to="/winners" style="color: #2c3e50; text-decoration: underline; font-size: 0.9em;"> ...eller se bilderna i din webbläsare.</router-link> -->
          </div>
        </div>
      </div>
        <div class="section white-section" style="padding-top: 20px;">
          <div class="content">
            <div class="inner-grid">
            <div class="body">
<p>
Tusentals fantastiska bilder laddades upp till Exhibition Stockholm. I den digitala utställningen länkad ovan kan ni se de bästa bilderna tagna på de olika fotoplatserna under tävlingens gång. Stort tack igen till alla som deltog och grattis till de vinnande bidragen!</p>

<p>Om du har några frågor kontakta oss på <a href="mailto:support@exhibitionstockholm.se" style="color: inherit;"><u>support@exhibitionstockholm.se</u></a></p>

            </div>
            <!--<div class="padding-40"></div>
              <div class="padding-80"></div>
              <div class="title-black">Om<br>utställningen</div>
              <div class="padding-20"></div>
              <div class="body-dark-grey">Tar du Sommarstockholms snyggaste foto?<br><br>Tävla om 30 000 kr och att få dina foton utställda i augmented reality i Kungsträdgården. Exhibition Stockholm pågår 29 juni – 4 augusti.
              </div>-->
            </div>
          </div>
        </div>
        <div class="padding-20"></div>
        <div class="winner-slides">
          <div class='winner-slide' v-for='slide in winnerSlides' v-bind:style="{ backgroundImage: 'url(' + './static/min/' + slide.image + ')'}">
            <div class='winner-text'><div class='blue-circle'></div> <span class='spot-title'>{{slide.spot}}</span> av <b>{{slide.username}}</b></div>
          </div>
        </div>
        <!-- <div class="section white-section">
          <div class="content">
            <div class="inner-grid">
              <div class="padding-40"></div>
              <div class="title-black">Så här<br>fungerade det</div>
              <div class="padding-20"></div>
              <div class="body-dark-grey">Att delta i Exhibition Stockholm är gratis och allt du behöver är en smartphone.<br><br>Runtom i Stockholm finns 54 hemliga fotoplatser. Du hittar dem genom att hålla upp din telefon och se dig omkring. Börja samla poäng genom att ta dig till en fotoplats, fota, redigera och ladda upp en bild i Exhibition Stockholms digitala galleri. Blir det du som i slutet av sommaren tagit Exhibition Stockholms vinnarbild från Observatorielunden, Skeppsholmsbron eller kön till Trädgården? (Oj, vi råkade visst ge dig några ledtrådar om vart du ska ta vägen.)<br><br>
Spelaren med flest poäng i slutet av tävlingen vinner 30 000 kronor. Den högst rankade bilden på varje fotoplats ställs ut i världens första utställning i augmented reality i Kungsträdgården.

              </div>
            </div>
          </div>
        </div> -->
      <div class='section'>
        <div class='inner-grid content'>
          <div class="lightroom-group">
              <div class="text-group">
                <div class="padding-80"></div>
                <div class='lightroom-logo'></div>
                <div class="padding-40"></div>
                <div class="title-black">Skaffa<br>Lightroom Mobile</div>
                <div class="padding-20"></div>
                <div class="body-dark-grey">Vill du ta dina mobilbilder till nästa nivå? Lär dig grunderna i fotoredigering! Det är lättare än du kanske tror.<br><br>Här kan du gratis ladda ned appen Lightroom Mobile. Med Lightroom Mobile kan du enkelt både ta och redigera bilder i din telefon. Exhibition Stockholm ger dig vassa och pedagogiska tips på hur du kan använda Lightroom Mobile för att fota och redigera bilder som proffsen.</div>
                <div class="padding-40"></div>
              </div>
          </div>
          <div class="iphone-mockup"></div>
          <div class="badge-group">
            <a href="https://play.google.com/store/apps/details?id=com.adobe.lrmobile" target="_blank" v-on:click='toGooglePlay'><div id="google-badge"></div></a>
            <a href="https://appsto.re/se/EXsy0.i" target="_blank" v-on:click='toAppStore'><div id="ios-badge"></div></a>
          </div>
          <div style="clear: both;"></div>
          <!-- <router-link to="/tutorial" class="blue-butt"></router-link> -->
          <div class="padding-80"></div>
        </div>
      </div>
      <div class='section start-bottom'>
        <div class="padding-20"></div>
        <ul class='bottom-menu'>
          <li></li>
          <li v-on:click="openRegler">Tävlingsregler & poäng</li>
          <li v-on:click="openTerms">Användar- & tävlingsvillkor</li>
          <li v-on:click="openSupport">Support</li>
          <li v-on:click="openOm">Om Adobe</li>
        </ul>
        <br>
        Adobe 2017
      </div>
  </div>
</template>

<script>
import firebaseApp from '@/classes/Db.js'
import thend from '@/json/thend.json'
export default {
  name: 'start',
  data () {
    return {
      msg: 'EXHIBITION STOCKHOLM',
      winnerSlides: [],
      hasDisCookie: false
    }
  },
  computed: {
    test () {
      return this.$store.state.userLocation.lat
    }
  },
  beforeMount () {
    if (this.$store.state.needsReload === true) {
      this.$store.commit('setNeedsReload', false)
      location.reload()
    }
    this.$store.commit('changeShowMenu', false)
  },
  mounted () {
    if (window.localStorage) {
      let hasSeenCookie = window.localStorage.getItem('hasSeenCookie')
      if (hasSeenCookie !== null) {
        this.hasDisCookie = true
      }
    }
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Start landing')
    }
    this.$store.commit('setHasBeenToStart', true)
    //  this.getWinners()
    this.getWinnersJson()
    this.makeCollage()
    /* let isNotDesktop = this.userOS()
    if (!isNotDesktop) {
      let html = 'Exhibition Stockholm är en webbapplikation för mobiltelefoner!<h6>För att delta i spelet gå in via din mobiltelefons webbläsare.</h6>'
      this.$store.commit('interupt', html)
    } */
    //  console.log(this.test)
  },
  methods: {
    toGooglePlay () {
      if (window.ga) {
        window.ga('send', 'event', 'Link', 'click', 'Lightroom Google Play')
      }
    },
    toAppStore () {
      if (window.ga) {
        window.ga('send', 'event', 'Link', 'click', 'Lightroom App store')
      }
    },
    userOS () {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (/windows phone/i.test(userAgent)) {
        return 'windowsphone'
      }
      if (/android/i.test(userAgent)) {
        return 'android'
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios'
      }
      return false
    },
    testingTouch (e) {
      //  console.log(e)
    },
    closeCookie () {
      var elem = document.getElementById('cookie-dis')
      if (window.localStorage) {
        window.localStorage.setItem('hasSeenCookie', true)
      }
      return elem.parentNode.removeChild(elem)
    },
    makeCollage () {
      console.log('making collage')
    },
    getRandomPos (index) {
      let top = 0
      let left = 0
      top = index * 11
      left = screen.width * Math.random() - 50
      return [top, left]
    },
    getRandomSize (index) {
      let width = 400 * Math.random() + 30
      let height = 400 * Math.random() + 30
      return [width, height]
    },
    getWinners () {
      let winners = []
      firebaseApp.database().ref('winner').once('value').then((snapshot) => {
        snapshot.forEach((photo) => {
          let photoVal = photo.val()
          winners.push(photoVal)
        })
        winners.sort((a, b) => {
          if (a.score < b.score) {
            return 1
          }
          if (a.score > b.score) {
            return -1
          }
          return 0
        })
        this.winnerSlides = winners.slice(0, 10)
        this.$nextTick(() => {
          window.$('.winner-slides').slick({
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true
          })
        })
      })
    },
    getWinnersJson () {
      this.winnerSlides = thend
      this.$nextTick(() => {
        window.$('.winner-slides').slick({
          dots: false,
          arrows: false,
          infinite: true,
          autoplay: true
        })
      })
    },
    openRegler () {
      if (window.ga) {
        window.ga('send', 'event', 'Page', 'enter', 'Regler & poäng')
      }
      let htmlString = ''
      // hämta från fil?
      htmlString = '<h1>TÄVLINGSREGLER OCH POÄNGSYSTEM</h1>'
      htmlString += '1. Du måste vara över 18 år för att delta.<br><br>2. Du får använda vilken kamera och vilket redigeringsverktyg du vill. (Använd gärna din telefon. Använder du den på rätt sätt lovar vi att du kan du sätta skräck i fotoproffsen. Vi ger dig tips på hur du utvecklar dina foton under vägen.)<br><br>3. Du får endast ladda upp bilder som du själv är upphovsman till. En bild kan endast ladda upp på en fotoplats och den måste vara tagen på fotoplatsen.<br><br>4. Du får ladda upp fler än en bild på en fotoplats, men det är endast din senast uppladdade bild du tävlar med. Du får 20 poäng för din första uppladdade bild på varje fotoplats.<br><br>5. Du får inte ladda upp bilder med olämpligt innehåll. För mer information om vad vi anser vara olämpligt innehåll, se våra användningsvillkor där du även hittar samtliga regler i sin helhet.<br><br>6. För varje ny fotoplats du hittar får du 10 poäng. <br><br>För varje ny fotoplats som du tar och laddar upp en bild på får du 20 poäng.<br><br>Efter att du fått minst fem röster på en bild kommer du få mellan 0 och 100 poäng för bilden baserat på hur andra röster på din bild. Antalet poäng på en bild kan ändras hela vägen fram till tävlingens slut och är procentuellt baserat på andelen positiva röster i förhållande till samtliga röster på bilden; exempelvis ger sju positiva av totalt tio röster 70 poäng.<br><br>7. Deltagaren med flest poäng vid tävlingens slut vinner tävlingen och 30 000 SEK i prispengar. 2-10 pristagarna vinner en årsprenumeration på Creative Cloud fotografi, värd 1433 SEK. De 54 bilder med högst poäng på varje fotoplats ställs ut i en augmented reality-utställning i Kungsträdgården, 21 - 27 augusti. Inget av priserna kan bytas ut mot pengar eller annat. Samtliga vinnare notifieras via e-post.'
      this.$store.commit('openTextPage', htmlString)
    },
    openTerms () {
      this.$store.commit('openTextPage', 'terms')
      this.$store.commit('setShowAgreement', true)
    },
    openSupport () {
      if (window.ga) {
        window.ga('send', 'event', 'Page', 'enter', 'Support')
      }
      let htmlString = ''
      htmlString = '<h1>Kontakta Support</h1>'
      htmlString += 'Har du tekniska problem med webbapplikationen, har du frågor eller vill du rapportera olämpligt material? Skriv till oss på <a href="mailto:support@exhibitionstockholm.se" target="_blank">support@exhibitionstockholm.se</a>'
      this.$store.commit('openTextPage', htmlString)
    },
    openOm () {
      if (window.ga) {
        window.ga('send', 'event', 'Page', 'enter', 'Om Adobe')
      }
      let htmlString = ''
      htmlString = '<h1>Om Adobe</h1>'
      htmlString += 'Adobe förändrar världen genom digitala upplevelser. Läs mer på <a href="http://www.adobe.com" target="_blank">www.adobe.com</a>'
      this.$store.commit('openTextPage', htmlString)
    }
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#collage {
  height: 50px;
}
.collage-item {
  height: 60px;
  width: 60px;
  display: inline-block;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
}
.cookiepop {
  background-color: #79C199;
  color: #fff;
  padding: 10px;
  font-size: 18px;
  position: absolute;
  top: 0px;
  width: 100%;
  box-sizing: border-box;
  z-index: 999;
}
.cookie-close {
  display: inline-block;
  margin-left: 10px;
}
.winner-slide {
  /*
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  position: relative; */
  height: 400px;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  outline: none;
}
.blue-circle {
  height: 4px;
  width: 4px;
}
.winner-text {
  position: absolute;
  bottom: 0px;
  padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
  margin: auto;
  width: 100%;
  font-size: 15px;
}
.spot-title {
  color: #2f4efd;
  text-transform: uppercase;
  font-weight: bold;
}
.start-view {
  z-index: 99999;
  background-color: #fff;
}
.start-bottom {
  background-color: #162935;
  padding-bottom: 50px;
  font-size: 16px;
  color: #fff;
}
.bottom-menu {

}
.bottom-menu li {
  display: block;
  padding: 20px;
  font-size: 22px;
  border-bottom: 1px solid;
  cursor: pointer; 
}
.bottom-menu li:hover {
  background-color: #294654;

}
.new-logo {
  height: 100px;
  display: inline-block;
  margin-top: 50px;
  width: 40px;
  background-position: center top;
  background-repeat: no-repeat;
  background-size: contain;
  /*margin-bottom: 30px;*/
  background-image: url('./../assets/logo_reg.svg');
  box-shadow: 0px 0px 80px rgba(255, 255, 255, 1);
  position: relative;
  z-index: 9;
}
/* MOBILE */
.section {
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  width: 100%; 
}
.start-section {
  position: relative;
}
.start-section .smile {
  position: absolute;
  z-index: -1;
}
.start-section .body {
  max-width: 600px;
  margin: auto;
}
.smile-sun {
  top: 37%;
  right: -50px;
}
.smile-key {
  height: 100px;
  width: 100px;
  top: -29px;
  right: 15%;
}
.smile-camera {
  height: 60px;
  width: 60px;
  top: 5%;
  left: -35px;
  transform: rotate(-3deg);
}
.smile-squares {
  height: 70px;
  width: 70px;
  top: 44%;
  left: -10px;
}
.smile-crop {
  height: 52px;
  width: 52px;
  bottom: 39%;
  right: 16%;
}
.smile-levers {
  height: 50px;
  width: 50px;
  top: 10%;
  right: 5%;
}
.smile-crown {
  top: 5%;
  left: 20%;
}
.blue-section {
  padding-bottom: 80px;
  background-color: #162935;
  background-color: #9ECEE5;
}
.title {
  height: 100px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 80%;
  background-image: url('./../assets/title.svg');
}
.adobe-logo {
  height: 100px;
  position: absolute;
  top: 0px;
  right: 40px;
  width: 55px;
  background-position: center top;
  background-repeat: no-repeat;
  background-size: contain;
  /*margin-bottom: 30px;*/
  background-image: url('./../assets/adobe.svg');
  text-shadow: 0px 0px 30px rgba(255, 255, 255, 1);
  position: relative;
  z-index: 9;
}
.exs-title {
  font-weight: 800;
  font-size: 30px;
  letter-spacing: 10px;
  margin-bottom: 5px;
  text-transform: uppercase;
  position: relative;
  z-index: 9;

}
.exs-sub-title {
  font-family: "jaf-domus-titling-web", Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 10px;
  text-transform: uppercase; 
  position: relative;
  z-index: 9;

}
.body-white {
  color: #fff;
  display: inline-block;
  font-size: 20px;
}
.body-grey {
  color: #fff;
  font-size: 20px;
  text-align: left;
}
.title-black {
  font-size: 35px;
  line-height: 42px;
  text-align: left;
}
.body-dark-grey {
  color: #4D4D4D;
  display: inline-block;
  font-size: 20px;
  text-align: left;
}
.title-white {
  font-size: 35px;
  line-height: 42px;
  text-align: left;
  color: #fff;
}
.inner-grid {
  margin: auto;
}
.placement {
  background-image: url('./../assets/placement-pic.png');
  height: 300px;
  background-size: 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
.lightroom-logo {
  background-image: url('./../assets/lightroom.svg');
  height: 90px;
  background-repeat: no-repeat;
  text-align: left;
}
.iphone-mockup {
  background-image: url('./../assets/iphone-mockup.png');
  height: 600px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}
#google-badge {
  float: left;
  width: 100%;
  background-image: url('./../assets/google-play-badge.png');
  height: 95px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}
#ios-badge {
  float: right;
  width: 100%;
  background-image: url('./../assets/app_store_badge.svg');
  height: 65px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}
/* > iphone 5 */
@media only screen and (min-width:330px) {
  .exs-title {
    font-size: 40px;
      margin-bottom: 10px;
  }
}
/* Desktop */
@media only screen and (min-width:1025px) {
  .exs-title {
    font-size: 50px;
      margin-bottom: 10px;
  }
  .exs-sub-title {
    font-size: 24px;
  }
  .title {
    padding-bottom: 80px;
    height: 140px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 550px;
    background-image: url('./../assets/title.svg');
  }
  .body-white {
    color: #fff;
    display: inline-block;
    font-size: 20px;
    line-height: 30px;
    width: 60%;
    max-width: 600px;
    padding-bottom: 40px;
  }
  .inner-grid {
    width: 800px;
    margin: auto;
  }
  .white-section {
    /*padding-bottom: 80px;
    background-color: #162935;
    color: #fff;
    padding-bottom: 100px;
    }*/
    display: inline-block;
    /*position: absolute;*/
    height: 100%;
    background-size: cover;
    background-color: #fff;
    padding-top: 120px;
    padding-bottom: 120px;
  }
  .title-black {
    font-size: 50px;
    line-height: 65px;
    text-align: left;
  }
  .body-dark-grey {
    float: left;
    color: #4D4D4D;
    font-size: 20px;
    text-align: left;
    width: 460px;
  }
  .placement {
    background-image: url('./../assets/placement-pic.png');
    height: 300px;
    background-color: #CFD8DC;
    background-size: 50%;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .title-white {
    font-size: 50px;
    line-height: 65px;
    text-align: left;
  }
  .body-grey {
    font-size: 20px;
    text-align: left;
    width: 460px;
  }
  .text-group {
    display: inline-block;
    width: 45%;
    float: left;
  }
  .lightroom-group {
    padding-top: 40px;
    padding-bottom: 120px;
  }
  .iphone-mockup {
    background-image: url('./../assets/iphone-mockup.png');
    height: 500px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    float: right;
    width: 45%;
  }
  .badge-group {
    display: inline-block;
    width: 100%;
    padding-top: 80px;
  }
  #google-badge {
    background-image: url('./../assets/google-play-badge.png');
    height: 100px;
    width: 50%;
    background-size: 80%;
    background-position: center center;
    background-repeat: no-repeat;
  }
  #ios-badge {
    background-image: url('./../assets/app_store_badge.svg');
    height: 100px;
    background-size: 65%;
    width: 50%;
    background-position: center center;
    background-repeat: no-repeat;
  }
}
</style>



// WEBPACK FOOTER //
// Start.vue?31b475e2